<script>
import { BDropdown } from 'bootstrap-vue'
import { attemptFocus } from 'bootstrap-vue/src/utils/dom'

export default {
  name: 'BDropdownCustom',
  extends: BDropdown,
  methods: {
    focusMenu() {
      attemptFocus(this.$refs.menu, {preventScroll: true})
    },
  },
}
</script>
